import React from 'react';
import NumberFormat from "react-number-format";
import Helper from './Helper';

class CalculateAddressShipping extends React.Component {
    constructor(props){
        super(props);
        let {selectedCity, selectedDistrict, selectedWard} = props;
        this.state = {
            isLoaded:false,
            cityData:[],
            districtData:[],
            wardData:[],
            currentDistricts:[],
            currentWards:[],
            selectedCity: selectedCity,
            selectedDistrict: selectedDistrict,
            selectedWard:selectedWard,
            shippingData: [],
            shippingFees: 0,
            shipping: true,
        }
    }

    updateShippingFees = () => {
        let {shippingData, selectedCity, selectedDistrict} = this.state;
        let {totalWeight} = this.props;
        let city = selectedCity ?? '00',
        district = selectedDistrict ?? '000';
        
        if(city !== '00' && district !='000')
        {
          let shipping = shippingData.filter(
            (item)=> (item.city === city && item.district && item.district === district)
          );
    
          if(!shipping.length)
          {
            shipping = shippingData.filter((item)=>(item.city === '00' && (item.district ? item.district && item.district === district:true)));
          }

          shipping = shipping.length ? shipping[0] : 0;
          let TempShippingFees = 0;
          if(shipping && Object.keys(shipping).length){
            let {weight_condition, next_step_condition_weight, next_step_price, time_schedule, fees} = shipping;
            TempShippingFees = parseInt(fees);
            if(totalWeight > parseFloat(weight_condition)){
                next_step_condition_weight = parseInt(next_step_condition_weight);
                let lvWeight = Math.ceil((totalWeight-parseFloat(weight_condition))/next_step_condition_weight);
                // console.log(lvWeight);
                TempShippingFees += lvWeight * parseInt(next_step_price);
            }
          }

          this.setState({
            shippingFees:TempShippingFees,
            shipping:shipping
          })
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if(nextProps.totalWeight != this.props.totalWeight)
        {
            this.updateShippingFees();
        }

        return true;
    }

    componentDidMount=()=>{
        Promise.all([
            fetch(Helper.getSiteUrl() + "/info/getAjaxCity"),
            fetch(Helper.getSiteUrl() + "/info/getAjaxDistrict",{
                method:'POST',
                body: JSON.stringify({city:this.props.selectedCity})
            }),
            fetch(Helper.getSiteUrl() + '/info/getAjaxWard',{
                method:'POST',
                body:JSON.stringify({district:this.props.selectedDistrict})
            }),
            fetch(Helper.getSiteUrl() + "/payment/getAjaxShippingFees"),
        ]).then(([res, res1,res2, res3])=>{
            return Promise.all([res.json(), res1.json(),res2.json(), res3.json()])
        }).then(([res,res1,res2, res3])=>{
            let districts = res1 && typeof res1.err === 'undefined' ? res1 : [],
            wards = res2 && typeof res2.err === 'undefined' ? res2 : [];
            this.setState({
                isLoaded:true,
                cityData:res,
                districtData: districts,
                currentDistricts: districts,
                wardData: wards,
                currentWards: wards,
                shippingData: res3 && typeof res3.err === 'undefined' ? res3:null,
            });

            this.updateShippingFees();
        })
    }

    handleChangeCity=(e)=>{
        let city = e.target.value,
        filterDistrict = [],
        filterWard = [],
        selectedDistrict = '00',
        selectedWard = '00000';
        if(city === this.props.selectedCity && city !== '00'){
            let {currentWards, currentDistricts} = this.state;
            filterDistrict = [...currentDistricts];
            filterWard = [...currentWards];
            this.setState({
                districtData:filterDistrict,
                wardData:filterWard,
                selectedCity:city,
                selectedDistrict:this.props.selectedDistrict,
                selectedWard:this.props.selectedWard,
                shippingFees: 0,
            });
        }else{
            city !== '00' && (
                fetch(Helper.getSiteUrl() + '/info/getAjaxDistrict',{
                    method:'POST',
                    body: JSON.stringify({city:city})
                }).then(res=>res.json())
                .then(res=>{
                    filterDistrict = res;
                    this.setState({
                        districtData:filterDistrict,
                        wardData:filterWard,
                        selectedCity:city,
                        selectedDistrict:selectedDistrict,
                        selectedWard:selectedWard,
                        shippingFees: 0,
                    });
                })
            );
        }
    }
    handleChangeDistrict=(e)=>{
        let district = e.target.value,
        filterWard = [],
        selectedWard = '00000';

        if(district === this.props.selectedDistrict && district !== '000'){
            let {currentWards} = this.state;
            filterWard = [...currentWards];
            this.setState({
                wardData:filterWard,
                selectedDistrict:district,
                selectedWard:this.props.selectedWard
            }, () => {
                this.updateShippingFees();
            });
        }else{
            district !== '000' && (
                fetch(Helper.getSiteUrl() + '/info/getAjaxWard',{
                    method:'POST',
                    body: JSON.stringify({district:district})
                }).then(res=>res.json())
                .then(res=>{
                    filterWard = res;
                    this.setState({
                        wardData:filterWard,
                        selectedDistrict:district,
                        selectedWard:selectedWard
                    }, () => {
                        this.updateShippingFees();
                    });
                })
            );
        }
    }
    handleChangeWard=(e)=>{
        let ward = e.target.value;
        this.setState({
            selectedWard:ward
        });
    }
    
    render(){
        let { shipping, shippingFees } = this.state;

        if(!this.state.isLoaded){
            return (
                <div>Loading</div>
            );
        }else{
            let {city, district, ward, address, addressText, requiredAddress} = this.props;
            const {cityData, districtData, wardData, selectedCity, selectedDistrict, selectedWard} = this.state;
            let options = cityData.length && cityData.map((item,index)=>(
                <option value={item.id} key={index}>{item.name}</option>
            )),
            optionsDistrict = districtData.length ? districtData.map((item, index)=>(
                <option value={item.maqh} key={index}>{item.name}</option>
            )):null,
            optionsWard = wardData.length ? wardData.map((item, index)=>(
                <option value={item.xaid} key={index}>{item.name}</option>
            )):null;
            return (
                <div className="row">
                    <div className="col-12 mt-2">
                        <label className="bold">
                           {this.props.title? this.props.title : "Địa chỉ"}
                        </label>
                        <i className="fas fa-truck ml-2"></i>
                    </div>
                    <div className='col-12 row'>
                        <div className="col-md-3 form-group mb-1">
                            <select required={requiredAddress} id="CityAddressDropdowList" 
                            onChange={this.handleChangeCity} value={selectedCity} 
                            className="form-control" name={city??'city'}>
                                <option value="00">-- Chọn thành phố --</option>
                                {options}
                            </select>
                        </div>
                        <div className="col-md-5 form-group mb-0">
                            <select required={requiredAddress} id="DistrictAddressDropdowList" 
                            onChange={this.handleChangeDistrict} 
                            value={selectedDistrict} className="form-control" name={district??'district'}>
                                <option value="000">-- Chọn quận huyện--</option>
                                {optionsDistrict}
                            </select>
                        </div>
                    </div>

                    { !this.props.hideWard &&
                        <div className="col-md-6 form-group">
                            <select required={requiredAddress} id="WardAddressDropdowList" 
                            onChange={this.handleChangeWard} 
                            value={selectedWard} className="form-control" name={ward??'ward'}>
                            <option value="00000">-- Chọn phường/xã/thị trấn--</option>
                                {optionsWard}
                            </select>
                        </div>
                    }

                    { !this.props.hideHouseNumber &&
                        <div className="col-md-6 col-12 form-group">
                            <input type="text" defaultValue={addressText} 
                            placeholder="Số nhà, tên đường" 
                            className="form-control" name="address" required={requiredAddress}
                            name={address??'address'} />
                        </div>
                    }

                    <div className="col-12 row mt-1">
                        {shipping ?
                        <>
                            <div className="col-12 bg-white">
                                <div className='pt-1'>
                                    <label className="form-check-label text-sm">
                                        <i className="shipping-dot fas fa-circle mr-3"></i>
                                        Khối lượng: 
                                        <strong className="text-danger ml-2">
                                            <NumberFormat value={parseFloat(this.props.totalWeight)} thousandSeparator="." 
                                            decimalSeparator=","
                                            displayType={"text"} renderText={(value)=>`${value} g`}/>  
                                        </strong>
                                    </label>
                                </div>
                            </div>
                            <div className="col-12 bg-white">
                                <label className="form-check-label text-sm">
                                    <i className="shipping-dot fas fa-circle mr-3"></i>
                                    Phí vận chuyển: 
                                    <strong className="text-danger ml-2">
                                        <NumberFormat value={parseFloat(shippingFees)} thousandSeparator="." 
                                        decimalSeparator=","
                                        displayType={"text"} renderText={(value)=>`${value} đ`}/>  
                                    </strong>
                                </label>
                            </div>
                        </> 
                        :null}
                    </div>
                </div>
            )
        }
    }
}
export default CalculateAddressShipping;